import { ProdutoCampoPersonalizadoService } from './../../services/produto-campo-personalizado.service';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CadastroOpcaoTabelaPersonalizadaModalComponent } from '../cadastro-opcao-tabela-personalizada-modal/cadastro-opcao-tabela-personalizada-modal.component';
import swal from 'sweetalert2';
import { CampoPersonalizado } from 'src/app/models/campo-personalizado';
import { CarregandoService } from 'src/app/services/carregando.service';
import { ClienteCampoPersonalizadoService } from 'src/app/services/cliente-campo-personalizado.service';
import { PedidoCampoPersonalizadoService } from 'src/app/services/pedido-campo-personalizado.service';
import { PaginatorService } from 'src/app/services/paginator.service';
import { AnaliseDescontoCampoPersonalizadoService } from 'src/app/services/analise-desconto-campo-personalizado.service';
import { CampoPersonalizadoService } from 'src/app/services/campo-personalizado.service';
import { CategoriaService } from 'src/app/services/categoria.service';
import { Categoria } from 'src/app/models/categoria';
import { TipoAplicacao } from 'src/app/models/enum';

// jquery
declare const $: any;

@Component({
  selector: 'app-cadastro-tabela-personalizada-modal',
  templateUrl: './cadastro-tabela-personalizada-modal.component.html',
  styleUrls: ['./cadastro-tabela-personalizada-modal.component.scss']
})
export class CadastroTabelaPersonalizadaModalComponent implements OnInit {

  tabela: CampoPersonalizado;
  tipoSelecionado = 0;
  tipoAplicacaoSelecionada = 0;

  public config: PerfectScrollbarConfigInterface = {};

  tiposTabela = [
    { id: 0, nome: 'Seleção Única' },
    { id: 1, nome: 'Seleção Múltipla' },
    { id: 2, nome: 'Texto' },
  ];

  tabelaAplicacao = [
    { id: 0, nome: 'Integrador' },
    { id: 1, nome: 'Pedido' },
    { id: 2, nome: 'Produto' },
    { id: 3, nome: 'Análise Desconto - Solicitação' },
    { id: 4, nome: 'Análise Desconto - Conclusão Positiva' },
    { id: 5, nome: 'Análise Desconto - Conclusão Negativa' }
  ];

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  carregando = true;
  campoOrdenacao = '';
  ordenarDesc = false;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;

  editavel = false;
  opcoesParaExclusao = [];

  categorias: Categoria[] = [];

  TipoAplicacao = TipoAplicacao;

  constructor(public dialogRef: MatDialogRef<CadastroTabelaPersonalizadaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private clienteCampoPersonalizadoService: ClienteCampoPersonalizadoService,
    private pedidoCampoPersonalizadoService: PedidoCampoPersonalizadoService,
    private produtoCampoPersonalizadoService: ProdutoCampoPersonalizadoService,
    private analiseDescontoCampoPersonalizadoService: AnaliseDescontoCampoPersonalizadoService,
    private campoPersonalizadoService: CampoPersonalizadoService,
    private paginatorService: PaginatorService,
    private categoriaService: CategoriaService
  ) {
    if (!!this.data && !!this.data.tabela) {
      this.tabela = this.data.tabela;
      this.tipoSelecionado = this.tabela.tipo;
      this.tipoAplicacaoSelecionada = this.tabela.tipoAplicacao;
    } else {
      this.tabela = new CampoPersonalizado();
      this.tabela.itens = [];
      this.tipoAplicacaoSelecionada = this.data.tipoTabela;
    }

    console.log(this.tabela);

    if (!!this.data && !!this.data.editavel)
      this.editavel = this.data.editavel;
  }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    if (this.tabela.id) {
      this.buscarTabela();
    }

    this.buscarCategorias();
  }

  buscarTabela() {
    this.carregandoService.mostra('buscarTabela');

    this.campoPersonalizadoService.consultarPorId(this.tabela.id).subscribe((res) => {
      this.tabela = res;
      this.carregandoService.esconde('buscarTabela');
    },
      (erro) => {
        this.carregandoService.esconde('buscarTabela');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarCategorias() {
    this.carregandoService.mostra('buscarCategorias');

    this.categoriaService.listar().subscribe((res) => {
      this.categorias = res;
      this.carregandoService.esconde('buscarCategorias');
    },
      (erro) => {
        this.carregandoService.esconde('buscarCategorias');
        this.notificacaoService.erro(erro);
      }
    );
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarTabela();
  }

  novaOpcao() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastroOpcaoTabelaPersonalizadaModalComponent, {
      width: largura > 800 ? '820px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card',
      data: {
        tabela: this.tabela
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (this.tabela.itens === null) {
          this.tabela.itens = [];
        }

        this.tabela.itens.push(result);

        this.salvar(true);
      }
    });
  }

  editarOpcao(opcao) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastroOpcaoTabelaPersonalizadaModalComponent, {
      width: largura > 800 ? '820px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card',
      data: {
        tabela: this.tabela,
        opcao: opcao
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (this.tabela.itens === null) {
          this.tabela.itens = [];
        }

        this.tabela.itens = this.tabela.itens.filter(p => p.id !== result.id);
        this.tabela.itens.push(result);

        this.salvar(true);
      }
    });
  }

  excluirOpcao(opcao) {
    this.carregandoService.mostra('verificarTabela');

    let service = null;

    switch (this.tipoAplicacaoSelecionada) {
      case 0:
        service = this.clienteCampoPersonalizadoService;
        break;
      case 1:
        service = this.pedidoCampoPersonalizadoService;
        break;
      case 2:
        service = this.produtoCampoPersonalizadoService;
        break;
      case 3:
      case 4:
      case 5:
        service = this.campoPersonalizadoService;
        break;
    }

    service.verificaSePodeExcluirItem(opcao.id).subscribe(
      (res) => {
        this.carregandoService.esconde('verificarTabela');

        if (res) {
          swal({
            title: 'Deseja realmente Excluir a Opção?',
            text: '',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-info',
            cancelButtonClass: 'btn btn-danger',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            buttonsStyling: false,
            type: 'warning'
          }).then((result) => {
            if (result.value) {
              opcao.excluir = true;

              this.carregandoService.mostra('salvarTabelaPersonalizada');

              let service = null;

              switch (this.tipoAplicacaoSelecionada) {
                case 0:
                  service = this.clienteCampoPersonalizadoService;
                  break;
                case 1:
                  service = this.pedidoCampoPersonalizadoService;
                  break;
                case 2:
                  service = this.produtoCampoPersonalizadoService;
                  break;
                case 3:
                case 4:
                case 5:
                  service = this.campoPersonalizadoService;
                  break;
              }

              service.salvar(this.tabela).subscribe(
                (res) => {
                  this.carregandoService.esconde('salvarTabelaPersonalizada');
                  this.notificacaoService.sucesso('Opção excluída com sucesso!!!');
                  this.buscarTabela();
                },
                (erro) => {
                  this.carregandoService.esconde('salvarTabelaPersonalizada');
                  this.notificacaoService.erro(erro);
                }
              );
            }
          });
        } else {
          this.notificacaoService.erro('Opção vinculada a um registro, não é possível excluí-la.');
        }
      },
      (erro) => {
        this.carregandoService.esconde('verificarTabela');
        this.notificacaoService.erro(erro);
      }
    );
  }

  salvar(listaOpcoes) {
    this.tabela.tipo = this.tipoSelecionado;
    this.tabela.itens = [...this.opcoesParaExclusao, ...(this.tabela.itens === null || this.tabela.itens === undefined ? [] : this.tabela.itens)];
    this.tabela.tipoAplicacao = this.tipoAplicacaoSelecionada;

    this.carregandoService.mostra('salvarTabelaPersonalizada');

    let campoPersonalizadoService = null;

    switch (this.tipoAplicacaoSelecionada) {
      case 0:
        campoPersonalizadoService = this.clienteCampoPersonalizadoService;
        break;
      case 1:
        campoPersonalizadoService = this.pedidoCampoPersonalizadoService;
        break;
      case 2:
        campoPersonalizadoService = this.produtoCampoPersonalizadoService;
        break;
      case 3:
      case 4:
      case 5:
        campoPersonalizadoService = this.campoPersonalizadoService;
        break;
    }

    campoPersonalizadoService.salvar(this.tabela).subscribe(
      (res: any) => {
        this.tabela.id = res.id;
        this.buscarTabela();
        this.carregandoService.esconde('salvarTabelaPersonalizada');
        if (!listaOpcoes) {
          this.notificacaoService.sucesso('Tabela salva com sucesso!!!');
          this.dialogRef.close(this.tabela);
        } else {
          this.notificacaoService.sucesso('Opção salva com sucesso!!!');
        }
      },
      (erro) => {
        this.carregandoService.esconde('salvarTabelaPersonalizada');
        this.notificacaoService.erro(erro);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }
}
